/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Bench_NameInputs */

const en_home_bench_name = /** @type {(inputs: Home_Bench_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A working day, with Lindevo`)
};

const lv_home_bench_name = /** @type {(inputs: Home_Bench_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darba diena ar Lindevo`)
};

/**
* | output |
* | --- |
* | "A working day, with Lindevo" |
*
* @param {Home_Bench_NameInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_bench_name = /** @type {((inputs?: Home_Bench_NameInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Bench_NameInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_bench_name(inputs)
	return en_home_bench_name(inputs)
});